

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminSession } from "@/lib/query/core/invalidation";

type AdminLoginInput = {
  email: string;
  password: string;
};

export function useLoginMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: AdminLoginInput) =>
      apiJsonClient<unknown>(endpoints.admin.auth.login, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }),
    onSuccess: async () => {
      await invalidateAdminSession(queryClient);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
